import { render, staticRenderFns } from "./PillButtons.vue?vue&type=template&id=31e8b9ae"
import script from "./PillButtons.vue?vue&type=script&lang=js"
export * from "./PillButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports